export const FETCH = "FETCH_ORDER";
export const FETCH_ALL = "FETCH_ALL_ORDER";
export const FETCH_NEW_ORDER = "FETCH_NEW_ORDER";
export const FETCH_DELETED_ORDER = "FETCH_DELETED_ORDER";
export const FETCH_ORDER_COUNT = "FETCH_ORDER_COUNT";